import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Account, ApiResponse } from '../models/account.model';
import { CreateVendorDTO } from '../models/create-vendor.dto';
import { UpdateVendorDTO } from '../models/update-vendor.dto';
import { UpdatePasswordDTO } from '../models/update-password.dto';
import { ResetPasswordDTO } from '../models/reset-password.dto';
import { ResetPasswordResponse } from '../models/reset-password-response.dto';
import { CreateTechnicianDTO } from '../models/create-technician.dto';

@Injectable({ providedIn: 'root' })
export class UtentiService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getAllAccounts(): Observable<ApiResponse<Account[]>> {
    return this.http.get<ApiResponse<Account[]>>(`${this.apiUrl}/account/accounts`);
  }

  getAccountById(accountId: number): Observable<ApiResponse<Account>> {
    return this.http.get<ApiResponse<Account>>(`${this.apiUrl}/account/${accountId}`);
  }

  registerAdmin(payload: {
    email: string;
    password: string;
    telephone_number: string;
    first_name: string;
    last_name: string;
  }): Observable<{ isSuccess: boolean; message: string } | any> {
    return this.http.post(`${this.apiUrl}/account/register-admin`, payload);
  }

  registerVendor(payload: CreateVendorDTO): Observable<{ isSuccess: boolean; message: string } | any> {
    return this.http.post(`${this.apiUrl}/account/register-vendor`, payload);
  }

  updateVendor(payload: UpdateVendorDTO): Observable<{ isSuccess: boolean; message: string } | any> {
    return this.http.put(`${this.apiUrl}/account/update-vendor`, payload);
  }

  updatePassword(payload: UpdatePasswordDTO): Observable<ApiResponse<any>> {
    return this.http.put<ApiResponse<any>>(`${this.apiUrl}/account/update-password`, payload);
  }

  resetPassword(payload: ResetPasswordDTO): Observable<ApiResponse<ResetPasswordResponse>> {
    return this.http.post<ApiResponse<ResetPasswordResponse>>(`${this.apiUrl}/account/reset-password`, payload);
  }

  registerTechnician(payload: CreateTechnicianDTO): Observable<{ isSuccess: boolean; message: string } | any> {
    return this.http.post(`${this.apiUrl}/account/register-technician`, payload);
  }

  disableAccount(accountId: number): Observable<ApiResponse<any>> {
    return this.http.post<ApiResponse<any>>(`${this.apiUrl}/account/${accountId}/disable`, {});
  }
}

